import React from 'react';
import { toJS } from 'mobx';
import { observer, inject } from 'mobx-react';
import { Modal, Button, Empty, Col, Radio, Input, Spin, message, TreeSelect } from 'antd';
import Zmage from 'react-zmage';

const { SHOW_ALL } = TreeSelect;
const { TextArea } = Input;

@inject('ecodeDemoStore', 'ecodeGenreStore')
@observer
class App extends React.Component {
  static defaultProps = {
    // prefixClsNow: 'sys-ecode-detailConfig',
  }
  constructor(props) {
    super(props);
    this.state = {

    }
  }
  render() {
    const { imgList, visible, onCancel, onChange, onOk, value, imgLoading, confirmLoading } = this.props;
    return (
      <Modal
        title="详细设置"
        visible={visible}
        style={{ top: 135 }}
        bodyStyle={{ maxHeight: 600, overflow: 'auto' }}
        width={800}
        onOk={() => typeof onOk === 'function' && onOk()}
        onCancel={() => typeof onCancel === 'function' && onCancel()}
        className="image-preview"
        confirmLoading={confirmLoading}
      >
        {
          imgList && imgList.length > 0 ? 
          <Radio.Group value={`${value}`} onChange={e => typeof onChange === 'function' && onChange(e.target.value)}>
            {
              imgList.map(img => {
                return (
                  <Col span={8} className="image-preview-col">
                    <div className="image-preview-zmage-box">
                      <Zmage className="image-preview-zmage" src={img.imageLink} alt="暂无预览" />
                    </div>
                    <Radio className="image-preview-radio" key={img.id} value={`${img.id}`}><span title={img.imageName}>{img.imageName}</span></Radio>
                  </Col>
                )
              })
            }
          </Radio.Group>
          : imgLoading ? <Spin spinning={imgLoading}><div style={{width: '100%', height: 134, textAlign: "center"}}></div></Spin> : <Empty description={'暂无预览'} image={Empty.PRESENTED_IMAGE_SIMPLE} />
        }
      </Modal>
    )
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/components/sys/ecodeDemo/ImgPreview.js